import React from 'react'
import LiveChat from 'react-livechat'
import getConfig from 'next/config'
import { execute } from '~/utils/nativeBridge'
import { captureException } from '~/lib/sentry'
import { useViewer } from '~/components/ViewerContext'
import { useLanguage } from '~/components/LanguageContext'
import cookies from 'js-cookie'

const LiveChatContext = React.createContext()
const { LIVECHAT_LICENSE } = getConfig().publicRuntimeConfig
export const LiveChatConsumer = LiveChatContext.Consumer

export function LiveChatProvider(props) {
  const initialMinimized = cookies.get('chatWindow') === 'minimized'
  const [minimized] = React.useState(initialMinimized)
  const initialShow = cookies.get('chatWindow') === 'minimized'
  const [show, setShow] = React.useState(initialShow)
  const { viewer, deviceInfo } = useViewer()
  const language = useLanguage()
  const visitor = viewer?.id && {
    name: viewer.firstname,
    email: viewer.email,
  }
  const params = viewer?.chatVerificationId && [
    { name: 'verificationId', value: viewer.chatVerificationId },
  ]

  let group = null
  switch (language) {
    case 'nl':
      group = 1
      break
    case 'fr':
      group = 3
      break
    case 'de':
      group = 4
      break
    case 'pt':
      group = 5
      break
    case 'hu':
      group = 7
      break
    case 'es':
      group = 9
      break
    case 'se':
      group = 10
      break
    case 'sk':
      group = 13
      break
    case 'cz':
      group = 14
      break
    default:
      group = 2
  }

  function handleChatLoaded(ref) {
    ref.on_after_load = () => {
      if (typeof global.LC_API === 'undefined') return false
      if (!minimized) global.LC_API.open_chat_window()
    }
  }

  function handleOpen() {
    const { isApp } = deviceInfo

    if (isApp) {
      return execute('openExternalUrl', {
        url: `https://lc.chat/now/${parseInt(LIVECHAT_LICENSE)}/${group}`,
      }).catch(error => {
        captureException('Native bridge call failed', 'native-bridge', {
          extra: {
            error,
          },
        })
      })
    }

    if (show) {
      if (typeof global.LC_API === 'undefined') return false
      global.LC_API.open_chat_window()
    } else {
      setShow(true)
    }
  }

  return (
    <LiveChatContext.Provider
      value={{
        open: handleOpen,
      }}
    >
      {props.children}
      {show && (
        <LiveChat
          license={parseInt(LIVECHAT_LICENSE)}
          onChatLoaded={handleChatLoaded}
          visitor={visitor}
          params={params}
          group={group}
          onChatWindowMinimized={() => cookies.set('chatWindow', 'minimized')}
          onChatWindowOpened={() => cookies.set('chatWindow', 'opened')}
        />
      )}
    </LiveChatContext.Provider>
  )
}
